module.exports = __webpack_public_path__ + "static/circles-5432ccdc1788f4381235aa762720c49e.png";